import React, { useRef } from "react";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import micro1 from "../../assets/cursorful1.mp4";
import work2 from "../../assets/work2.mp4";

const projects = [
  {
    title: "Animated Hero Section",
    description: "An animated hero section with a loader and smooth transitions created using code, inspired by zajno.com's landing page",
    technologies: ["React.js", "Tailwind CSS", "GSAP"],
    video: micro1,
  },
  {
    title: "Chat Input Options Interaction",
    description: "An interactive chat input options display with smooth transition effects",
    technologies: ["React.js", "Framer Motion", "TailwindCSS"],
    video: work2,
  },
];

const ProjectDetailsPage = () => {
  const videoRefs = useRef([]);
  const buttonRefs = useRef([]);

  const handlePlayPause = (index) => {
    const video = videoRefs.current[index];
    const button = buttonRefs.current[index];
    
    if (video.paused) {
      video.play();
      button.textContent = "Pause";
    } else {
      video.pause();
      button.textContent = "Play";
    }
  };

  return (
    <div className="page pt-20">
      <Navbar />
      <div className="container mx-auto px-10 py-10">
        <h1 className="text-3xl font-bold text-neutral-300 mb-6">Microinteractions Collection</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {projects.map((project, index) => (
            <div key={index} className="p-6 border border-neutral-800 rounded-lg shadow-md">
              <h2 className="text-xl text-neutral-300 font-semibold mb-2">{project.title}</h2>
              <p className="text-neutral-500 mb-4">{project.description}</p>
              
              <h3 className="text-sm font-semibold mb-2 text-neutral-300">Technologies Used:</h3>
              <div className="flex flex-wrap gap-2 mb-8">
                {project.technologies.map((tech, i) => (
                  <span 
                    key={i} 
                    className="border border-neutral-500 text-xs font-medium px-2.5 py-0.5 rounded-full"
                  >
                    {tech}
                  </span>
                ))}
              </div>
              
              <div className="relative">
                <video
                  ref={(el) => (videoRefs.current[index] = el)}
                  className="w-full rounded-lg mb-4"
                  src={project.video}
                  preload="metadata"
                />
                <button
                  ref={(el) => (buttonRefs.current[index] = el)}
                  onClick={() => handlePlayPause(index)}
                  className="mt-2 font-bold text-base px-10 py-4 rounded-[6rem] bg-[#A2BC6B] shadow-inset shadow-[rgba(255, 255, 255, 0.28)] text-black"
                >
                  Play
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ProjectDetailsPage;